export const SHADOW_ARG = "_i_o";
export const RETURN_ARG = "return";
